<div class="container">
  <app-general-header title="District Branding" />
  <div class="card border-0 p-3 table-container">
    <app-settings-nav [districtCode]="districtCode"></app-settings-nav>
    <div class="card-body">
      <ng-container *ngIf="!isLoading; else loadingTemplate">
        <div class="row mb-4 justify-content-center flex-column flex-lg-row">
          <div class="col col-lg-2 me-3 mb-3 mb-lg-0">
            <p class="fw-bold mb-2">Preview:</p>
            <div class="col-12">
              <ul
                class="preview-nav d-flex flex-row flex-lg-column align-items-center rounded"
                [ngStyle]="{ 'background-color': payload.bg_color }">
                <li
                  class="px-3 pt-3 pb-4 bg-primary rounded-top preview-nav-gl-logo">
                  <img
                    id="groweLabLogo"
                    width="100%"
                    src="assets/logo_light.png"
                    alt="GroweLab Logo" />
                </li>
                <li *ngIf="logoPath" class="bg-transparent preview-nav-logo">
                  <img
                    id="districtLogo"
                    width="100%"
                    class="py-lg-3 px-3"
                    src="{{ logoPath }}"
                    alt="District Logo" />
                </li>
                <li
                  class="preview-nav-item w-100"
                  *ngFor="let item of previewItems">
                  <button
                    type="button"
                    class="w-100 nav-link border-0 p-3 d-flex align-items-center flex-column justify-content-center"
                    (click)="setPreviewActive(item.key)"
                    [ngStyle]="{
                      'background-color':
                        previewActiveNav === item.key
                          ? payload.active_bg_color
                          : 'transparent',
                      color:
                        previewActiveNav === item.key
                          ? payload.active_link_color
                          : payload.link_color
                    }">
                    <i
                      [ngClass]="['bi', 'bi-' + item.icon, 'fs-24']"
                      [ngStyle]="{
                        color:
                          previewActiveNav === item.key
                            ? payload.active_link_color
                            : payload.link_color
                      }"></i>
                    <span
                      class="fs-12 fw-800 mt-2"
                      [ngStyle]="{
                        color:
                          previewActiveNav === item.key
                            ? payload.active_link_color
                            : payload.link_color
                      }">
                      {{ item.label }}
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-lg-8">
            <div class="row mb-3">
              <p class="fw-bold mb-2">Logo:</p>
              <div *ngIf="logoPath; else logoUpload" class="d-flex">
                <div class="logo-preview">
                  <img
                    id="districtLogo"
                    class="district-logo-preview"
                    width="100%"
                    src="{{ logoPath }}"
                    alt="District Logo" />
                </div>
                <button
                  aria-label="delete logo button"
                  class="btn btn-txt-delete"
                  type="button"
                  style="height: fit-content"
                  (click)="deleteAttachment()"
                  ngbTooltip="Delete Logo">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
              <ng-template #logoUpload>
                <app-file-upload
                  #uploadComponent
                  [style]="uploadStyle"
                  [allowedFileTypes]="allowedFileTypes"
                  (outputFiles)="updateAttachments($event)" />
              </ng-template>
            </div>
            <div class="row mb-1">
              <div class="d-flex justify-content-between align-items-start">
                <p class="fw-bold mb-2">Colors:</p>
                <button
                  class="btn btn-link mb-2 pt-0"
                  (click)="resetToDefaultColors()">
                  Reset to default
                </button>
              </div>
              <div class="col d-flex flex-column align-items-center">
                <div class="color-picker-container">
                  <input
                    type="color"
                    [(ngModel)]="payload.bg_color"
                    (change)="updateColor($event, 'background')"
                    class="color-picker" />
                </div>
                <p class="mt-2 fs-13 fw-bold mb-2 text-center">Background</p>
              </div>
              <div class="col d-flex flex-column align-items-center">
                <div class="color-picker-container">
                  <input
                    type="color"
                    [(ngModel)]="payload.link_color"
                    (change)="updateColor($event, 'link')"
                    class="color-picker" />
                </div>
                <p
                  class="mt-2 fs-13 fw-bold mb-2 text-center"
                  style="white-space: nowrap">
                  Link
                </p>
              </div>
              <div class="col d-flex flex-column align-items-center">
                <div class="color-picker-container">
                  <input
                    type="color"
                    [(ngModel)]="payload.active_bg_color"
                    (change)="updateColor($event, 'active_background')"
                    class="color-picker" />
                </div>
                <p class="mt-2 fs-13 fw-bold mb-2 text-center">
                  Active Background
                </p>
              </div>
              <div class="col d-flex flex-column align-items-center">
                <div class="color-picker-container">
                  <input
                    type="color"
                    [(ngModel)]="payload.active_link_color"
                    (change)="updateColor($event, 'active_link')"
                    class="color-picker" />
                </div>
                <p
                  class="mt-2 fs-13 fw-bold mb-2 text-center"
                  style="white-space: nowrap">
                  Active Link
                </p>
              </div>
            </div>

            <div class="contrast-checker mt-3 p-3 rounded">
              <p class="fw-bold mb-3">Accessibility Contrast Checks</p>
              <p class="mb-3 fs-13 text-muted">
                Please check the contrast on your color choices to ensure they
                meet accessibility requirements for your organization.
              </p>

              <div class="row g-3 mb-3">
                <div class="col-12 col-lg-6">
                  <div
                    class="contrast-preview rounded p-3"
                    [ngStyle]="{
                      'background-color': payload.bg_color,
                      color: payload.link_color
                    }">
                    <p class="fw-bold mb-1">Link on Background</p>
                    <p class="mb-0">Ratio: {{ defaultContrastRatio }}:1</p>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div
                    class="contrast-preview rounded p-3"
                    [ngStyle]="{
                      'background-color': payload.active_bg_color,
                      color: payload.active_link_color
                    }">
                    <p class="fw-bold mb-1">Active Link on Active Background</p>
                    <p class="mb-0">Ratio: {{ activeContrastRatio }}:1</p>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th scope="col">WCAG Check</th>
                      <th scope="col">Required</th>
                      <th scope="col">Link + Background</th>
                      <th scope="col">Active Link + Active Background</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Normal text (AA)</td>
                      <td>{{ wcagThresholds.normalTextAA }}:1</td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.normalTextAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.normalTextAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.normalTextAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.normalTextAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Non-text icons / graphics (AA)</td>
                      <td>{{ wcagThresholds.uiComponentsAA }}:1</td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.uiComponentsAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.uiComponentsAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.uiComponentsAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.uiComponentsAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Normal text (AAA)</td>
                      <td>{{ wcagThresholds.normalTextAAA }}:1</td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.normalTextAAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              defaultContrastRatio,
                              wcagThresholds.normalTextAAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="contrast-badge"
                          [ngClass]="
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.normalTextAAA
                            )
                              ? 'pass'
                              : 'fail'
                          ">
                          {{
                            isPassingContrast(
                              activeContrastRatio,
                              wcagThresholds.normalTextAAA
                            )
                              ? "Pass"
                              : "Fail"
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-secondary me-2" (click)="resetChanges()">
            Cancel
          </button>
          <button
            class="btn btn-primary"
            (click)="saveBranding()"
            [disabled]="submitLoading">
            <span
              *ngIf="submitLoading"
              class="spinner-border spinner-border-sm me-1"></span>
            Save Changes
          </button>
        </div>
      </ng-container>
      <ng-template #loadingTemplate>
        <div
          class="w-100 position-relative"
          style="background-color: #fff; height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>
    </div>
  </div>
</div>
